<template>
	<!-- HEADER -->
	<div >
        <el-row>
            <el-col :span="24" style="text-align: left;"><el-button type="primary" size="small" round @click="openDialog(null)" >修改</el-button></el-col>
        </el-row>
		<el-row>
			<img :src="listData.img" style="max-height: 560px;">
		</el-row>
        <el-dialog
          title="提示"
          :visible.sync="dialogVisible"
          width="30%">
          <el-form :model="currentRow">
            
            <el-form-item label="图片" :label-width="formLabelWidth">
              <el-upload
                class="avatar-uploader"
                action="" 
                :before-upload="beforeUpload"
                :show-file-list="false"
                :on-change="handleFileChange"
              :file-list="fileList"  
                >
                <img v-if="isImage" :src="currentRow.img" class="avatar"  />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="saveInfo">确 定</el-button>
            <el-button @click="dialogVisible = false">取 消</el-button>
          </div>
        </el-dialog>
	</div>
	<!--- END HEADER -->
</template>

<script>
	import {submitCenterPic,getCenterPic} from "@/api/rbac/home";
export default {
	data() {
		return {
			currentIndex: 0,
            listData:{img:'../../assets/img/OEM.png'},
            dialogVisible:false,
            currentRow:{},
            formLabelWidth:'120px',
			fileList:[],
			isImage:false,
		};
	},
    created() {
            this.loadDataList();
          },
	methods: {
		async loadDataList() {
            try {
				const params1={unionID:0,strType:'main'}
                getCenterPic(params1).then(res=>{
                    if (res.data.length==0) {
                        // console.log(this.dataList)
                    }
                    else{
                        res.data.forEach(comNew => {
                            this.listData.img="../../../assets/img/Main/"+comNew.name;
                        });
                    }
                })
            } catch (error) {
            console.error('获取失败:', error);
            }
        },
        openDialog(item){
			if (this.listData.length==0) {
				this.currentRow={img:''}
			}
			else{
				this.currentRow={img:this.listData.img}
			}
			if (this.currentRow.img==undefined||this.currentRow.img.length==0) {
				this.isImage=false;
			}
			else{
				this.isImage=true;
			}
			
			console.log(item)
			this.dialogVisible=true;
        },
		closeDialog(){
			this.dialogVisible=false;
			this.currentRow={img:''}
		},
		beforeUpload(file) {
            console.log(file)
            return false; // 阻止自动上传
        },
        handleFileChange(file, fileList) {
            console.log('fileList',fileList)
            this.fileList=[];
            this.fileList.push(file)
            if (file.status === 'ready') {
                // 当文件状态为 ready 时，生成预览 URL
                const reader = new FileReader();
                reader.onload = (e) => {
                this.currentRow.img = e.target.result;
                };
                reader.readAsDataURL(file.raw);
            }
        },
		async saveInfo(){
			const formData = new FormData();
			if (this.fileList.length==0) {
				this.dialogVisible=false;
				this.currentRow={img:''};
			}
			else{
				this.fileList.forEach((file) => {
				formData.append('files[]', file.raw);
				});
				formData.append("strType","main");
				formData.append("partID",0);
				try {
					submitCenterPic(formData).then(res=>{
						if (res.length==0) {
							alert('失败');
						}
						else{
							alert('成功');
							this.dialogVisible=false;
							this.currentRow={url:''};
							this.loadDataList();
						}
					})
				} catch (error) {
					alert('未成功');
				}
			}
		},
	},

}
</script>

<style scoped>
@import '../../assets/css/main.css';
@media (max-width: 768px) {
	:deep(.overlay .container .p-5) {
		padding: 1rem !important;
	}
}

@media (max-width: 768px) {
	:deep(.overlay .container .font-weight-light) {
		display: none;
	}
}
.pHeader{
	color: white;
	background: red;
	font-size: 30px;
	display: inline-block;
    vertical-align: top; 
	padding: 0px 15px;
	font-weight: bold;
	font-family: 'DengXian', 'DengXian Mono', sans-serif;
}
:deep(.video-container) {
	position: relative;
	margin: 0 auto;
}

:deep(.video-container video) {
	width: 100%;
	height: auto;
	display: block;
	object-fit: cover;
	max-height: 800px;
}

:deep(.carousel-container) {
	position: relative;
	margin: 0 auto;
	overflow: hidden;
}

:deep(.carousel) {
	display: flex;
	transition: transform 0.5s ease-in-out;
}

:deep(.carousel-video) {
	min-width: 100%;
}

:deep(.overlay) {
	position: absolute !important;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	color: white;
	text-align: center;
	background: rgba(0, 0, 0, 0.4);
	z-index: 1;
	pointer-events: none;
}

:deep(.dots) {
	position: absolute;
	top: unset;
	bottom: 1.25rem;
}
</style>
